// extracted by mini-css-extract-plugin
module.exports = {"light-text-color":"#fff","dark-text-color":"#374151","default-placeholder-color":"#fff"};